import { Gauge } from "lucide-react";
import useFeatures from "../../hooks/useFeatures";
import { useAuth } from "../../context/authContext";
import GlassCard from "../ui/GlassCard";
import ProgressBar from "../ui/ProgressBar";
const Features = ({ name }) => {
  const { code } = useAuth();
  const { features } = useFeatures(code);
  return (
    <GlassCard accent="violet" className="flex h-full flex-col text-slate-900 dark:text-white">
      <h1 className="font-['Space_Grotesk',_sans-serif] text-[22px] font-semibold mb-4">{name}</h1>
      <div className="flex flex-1 flex-col gap-4">
        <div className="flex-1">
          <ProgressBar icon={<Gauge size={14} className="text-[#64b5f6]" />} value={features?.moodCount ?? 0} label="Mood Tracker" color="#64b5f6" />
        </div>
        <div className="flex-1">
          <ProgressBar icon={<Gauge size={14} className="text-[#45D9C0]" />} value={features?.testCount ?? 0} label="Psychometric Tests" color="#45D9C0" />
        </div>
        <div className="flex-1">
          <ProgressBar icon={<Gauge size={14} className="text-[#F5B14C]" />} value={features?.selfCareCount ?? 0} label="Self Care Cards" color="#F5B14C" />
        </div>
      </div>
    </GlassCard>
  );
};
var Features_default = Features;
export { Features_default as default };